import styled from 'styled-components';
import highlight from 'assets/images/highlight.jpg';
import { fonts } from 'styles';

export const Container = styled.header`
  width: 100%;
  height: 100vh;
  display: flex;

  @media screen and (max-width: 960px) {
    flex-direction: column;
    min-height: 100vh;
    height: 100%;
  }
`;

export const Content = styled.div`
  height: 100vh;

  &.left {
    max-width: 60%;
    flex: 1;
  }

  &.right {
    min-width: 40%;
  }

  @media screen and (max-width: 960px) {
    height: auto;
    &.left {
      max-width: 100%;
    }

    &.right {
      min-width: 100%;
    }
  }
`;

export const HighlightImage = styled.img.attrs({ src: highlight })`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Eye = styled.div`
  width: 100%;
  height: 100vh;
  background: #e65930;
  padding: 64px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  position: relative;

  @media screen and (max-width: 960px) {
    height: auto;
    margin-top: -4px;
    padding-bottom: 45px;
  }
`;

export const Title = styled.h1`
  font-family: ${fonts.BentonSansWideBlack};
  font-size: 60px;
  line-height: 64px;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 24px;

  @media screen and (max-width: 500px) {
    font-size: 48px;
    line-height: 52px;
  }
`;

export const Subtitle = styled.h2`
  font-family: ${fonts.PlayfairDisplay};
  font-size: 28px;
  line-height: 34px;
  text-align: center;
  margin-bottom: 48px;
`;

export const Author = styled.h3`
  font-family: ${fonts.BentonSansRegular};
  font-size: 18px;
  line-height: 22px;
  text-align: center;
`;

export const Legend = styled.div`
  font-family: ${fonts.BentonSansRegular};
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  position: absolute;
  bottom: 45px;

  @media screen and (max-width: 960px) {
    position: relative;
    bottom: unset;
    margin-top: 64px;
  }
`;
